import { TaxIdType } from './person'

export type FiscalNoteTaxIdType = TaxIdType | 'foreign'

export enum FiscalNoteStatusEnum {
  emission_requested = 'Emitindo',
  emitted = 'Emitida',
  error = 'Erro',
  cancellation_requested = 'Cancelando',
  canceled = 'Cancelada',
  waiting_files = 'Aguardando arquivos',
}

export type FiscalNoteStatus = keyof typeof FiscalNoteStatusEnum

export type FiscalNoteFileType = 'xml' | 'pdf'

export type FiscalNote = {
  id: number
  key: string
  description: string
  value: number
  status: FiscalNoteStatus
  tax_inss?: number
  tax_csll?: number
  tax_irrf?: number
  tax_pis?: number
  tax_cofins?: number
  iss_retention: boolean
  borrower: {
    key: string
    name: string
    tax_id: string
    tax_id_type: FiscalNoteTaxIdType
  }
  service_code: {
    id: number
    code: string
    label: string
    service_tax_rate?: number
  }
  cnae_id: number
  emission_date: string
  serial_number?: string
  error_message?: string
  municipality: {
    ibge_code: string
    state: string
  }
}

export type IssueFiscalNotePayload = {
  value: number
  description: string
  borrower_key: string
  service_code_id: number
  cnae_id: number
  service_tax_rate: number
  service_tax_code?: string
  municipality_ibge_code?: string
  serial_number?: string
  inss?: number
  csll?: number
  irrf?: number
  pis?: number
  cofins?: number
  iss_retention?: boolean
  emission_date?: string
  ignore_municipality_requirements?: boolean
}
